import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VStepper,
    {
      attrs: { vertical: "" },
      model: {
        value: _vm.currentStep,
        callback: function ($$v) {
          _vm.currentStep = $$v
        },
        expression: "currentStep",
      },
    },
    [
      _c(
        VStepperStep,
        {
          attrs: {
            step: "1",
            complete: _vm.currentStep > 1,
            editable: _vm.currentStep > 1,
          },
          on: {
            click: function ($event) {
              return _vm.goToPrevStep(1)
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$vuetify.lang.t("$vuetify.processConversionReport.step1")
              ) +
              " "
          ),
        ]
      ),
      _c(
        VStepperContent,
        { attrs: { step: "1" } },
        [
          _c(
            VForm,
            {
              ref: "dateForm",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.goToNextStep(2)
                },
              },
              model: {
                value: _vm.dateValid,
                callback: function ($$v) {
                  _vm.dateValid = $$v
                },
                expression: "dateValid",
              },
            },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(
                        VMenu,
                        {
                          attrs: {
                            "close-on-content-click": false,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "auto",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    VTextField,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            label: _vm.$vuetify.lang.t(
                                              "$vuetify.base.startDate"
                                            ),
                                            "prepend-icon": "mdi-calendar",
                                            readonly: "",
                                            rules: [_vm.rules.required],
                                          },
                                          model: {
                                            value: _vm.params.startDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.params,
                                                "startDate",
                                                $$v
                                              )
                                            },
                                            expression: "params.startDate",
                                          },
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.startMenu,
                            callback: function ($$v) {
                              _vm.startMenu = $$v
                            },
                            expression: "startMenu",
                          },
                        },
                        [
                          _c(VDatePicker, {
                            on: {
                              input: function ($event) {
                                _vm.startMenu = false
                              },
                            },
                            model: {
                              value: _vm.params.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "startDate", $$v)
                              },
                              expression: "params.startDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(
                        VMenu,
                        {
                          attrs: {
                            "close-on-content-click": false,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "auto",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    VTextField,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            label: _vm.$vuetify.lang.t(
                                              "$vuetify.base.endDate"
                                            ),
                                            "prepend-icon": "mdi-calendar",
                                            readonly: "",
                                            rules: [
                                              _vm.rules.required,
                                              _vm.rules.endAfterStart,
                                            ],
                                          },
                                          model: {
                                            value: _vm.params.endDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.params,
                                                "endDate",
                                                $$v
                                              )
                                            },
                                            expression: "params.endDate",
                                          },
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.endMenu,
                            callback: function ($$v) {
                              _vm.endMenu = $$v
                            },
                            expression: "endMenu",
                          },
                        },
                        [
                          _c(VDatePicker, {
                            on: {
                              input: function ($event) {
                                _vm.endMenu = false
                              },
                            },
                            model: {
                              value: _vm.params.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "endDate", $$v)
                              },
                              expression: "params.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { disabled: !_vm.dateValid, color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.goToNextStep(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.next")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VStepperStep,
        {
          attrs: {
            step: "2",
            complete: _vm.currentStep > 2,
            editable: _vm.currentStep > 1,
          },
          on: {
            click: function ($event) {
              return _vm.goToPrevStep(2)
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$vuetify.lang.t("$vuetify.processConversionReport.step2")
              ) +
              " "
          ),
        ]
      ),
      _c(
        VStepperContent,
        { attrs: { step: "2" } },
        [
          _c(
            VForm,
            {
              ref: "processForm",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.goToNextStep(3)
                },
              },
              model: {
                value: _vm.processValid,
                callback: function ($$v) {
                  _vm.processValid = $$v
                },
                expression: "processValid",
              },
            },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VRow,
                        _vm._l(
                          _vm.selectedProcessTypes,
                          function (processType, index) {
                            return _c(
                              VCol,
                              {
                                key: processType
                                  ? processType.id
                                  : `placeholder-${index}`,
                                staticClass: "d-flex align-center",
                                attrs: { cols: "12", sm: "6" },
                              },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    items: _vm.getProcessTypesForIndex(index),
                                    "item-text": "name",
                                    "item-value": "id",
                                    label: `${_vm.$vuetify.lang.t(
                                      "$vuetify.processConversionReport.processTypes"
                                    )} ${index + 1}`,
                                    rules: [_vm.rules.required],
                                    "return-object": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleProcessTypeChange(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedProcessTypes[index],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedProcessTypes,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "selectedProcessTypes[index]",
                                  },
                                }),
                                index < _vm.selectedProcessTypes.length - 1
                                  ? _c(VIcon, { staticClass: "ml-2" }, [
                                      _vm._v(" mdi-arrow-right "),
                                    ])
                                  : _vm._e(),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      icon: "",
                                      color: "red",
                                      disabled:
                                        _vm.selectedProcessTypes.length === 1,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeProcessTypeSelection(
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [_c(VIcon, [_vm._v("mdi-delete")])],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    color: "primary",
                                    disabled: !_vm.canAddProcessType,
                                  },
                                  on: { click: _vm.addProcessType },
                                },
                                [
                                  _c(VIcon, { attrs: { left: "" } }, [
                                    _vm._v("mdi-plus"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.processConversionReport.addProcessType"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.goToPrevStep(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.back")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            disabled: !_vm.processValid,
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToNextStep(3)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.next")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VStepperStep,
        {
          attrs: {
            step: "3",
            complete: _vm.currentStep > 3,
            editable: _vm.currentStep > 2,
          },
          on: {
            click: function ($event) {
              return _vm.goToPrevStep(3)
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$vuetify.lang.t("$vuetify.processConversionReport.step3")
              ) +
              " "
          ),
        ]
      ),
      _c(
        VStepperContent,
        { attrs: { step: "3" } },
        [
          _c(
            VForm,
            {
              ref: "inputOutputForm",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.goToNextStep(4)
                },
              },
              model: {
                value: _vm.inputOutputValid,
                callback: function ($$v) {
                  _vm.inputOutputValid = $$v
                },
                expression: "inputOutputValid",
              },
            },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          items: _vm.groupedInputItems,
                          "item-text": "name",
                          "item-value": "id",
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.processConversionReport.inputProducts"
                          ),
                          multiple: "",
                          loading: _vm.isInputProductsLoading,
                          rules: [_vm.rules.required],
                          chips: "",
                          "deletable-chips": "",
                          clearable: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                item.header
                                  ? _c(VSubheader, [
                                      _vm._v(_vm._s(item.header)),
                                    ])
                                  : _c("div", [_vm._v(_vm._s(item.name))]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.params.inputProductIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "inputProductIds", $$v)
                          },
                          expression: "params.inputProductIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          items: _vm.groupedOutputItems,
                          "item-text": "name",
                          "item-value": "id",
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.processConversionReport.outputProducts"
                          ),
                          multiple: "",
                          loading: _vm.isOutputProductsLoading,
                          rules: [_vm.rules.required],
                          chips: "",
                          "deletable-chips": "",
                          clearable: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                item.header
                                  ? _c(VSubheader, [
                                      _vm._v(_vm._s(item.header)),
                                    ])
                                  : _c("div", [_vm._v(_vm._s(item.name))]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.params.outputProductIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "outputProductIds", $$v)
                          },
                          expression: "params.outputProductIds",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.goToPrevStep(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.processConversionReport.back"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            disabled: !_vm.inputOutputValid,
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToNextStep(4)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.next")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VStepperStep,
        {
          attrs: {
            step: "4",
            complete: _vm.currentStep > 4,
            editable: _vm.currentStep > 3,
          },
          on: {
            click: function ($event) {
              return _vm.goToPrevStep(4)
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$vuetify.lang.t("$vuetify.processConversionReport.step4")
              ) +
              " (" +
              _vm._s(_vm.$vuetify.lang.t("$vuetify.base.optional")) +
              ") "
          ),
        ]
      ),
      _c(
        VStepperContent,
        { attrs: { step: "4" } },
        [
          _c(
            VForm,
            {
              ref: "processForm",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.emitReportParameters.apply(null, arguments)
                },
              },
              model: {
                value: _vm.processValid,
                callback: function ($$v) {
                  _vm.processValid = $$v
                },
                expression: "processValid",
              },
            },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          items: _vm.statusOptions,
                          "item-text": "text",
                          "item-value": "value",
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.processConversionReport.statusFilter"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.processStatusFilter,
                          callback: function ($$v) {
                            _vm.processStatusFilter = $$v
                          },
                          expression: "processStatusFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-1 process-table",
                        attrs: {
                          headers: _vm.processTableHeaders,
                          items: _vm.filteredAvailableProcesses,
                          loading: _vm.isProcessesLoading,
                          "item-key": "id",
                          "show-select": "",
                          "items-per-page": 10,
                          "footer-props": {
                            "items-per-page-options": [5, 10, 15],
                            "items-per-page-text": _vm.$vuetify.lang.t(
                              "$vuetify.dataTable.itemsPerPageText"
                            ),
                            "show-current-page": true,
                          },
                          search: _vm.processSearch,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "top",
                            fn: function () {
                              return [
                                _c(
                                  VToolbar,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(VToolbarTitle, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.processConversionReport.processes"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(VDivider, {
                                      staticClass: "mx-4",
                                      attrs: { inset: "", vertical: "" },
                                    }),
                                    _c(VSpacer),
                                    _c(VTextField, {
                                      attrs: {
                                        "append-icon": "mdi-magnify",
                                        label: _vm.$vuetify.lang.t(
                                          "$vuetify.base.search"
                                        ),
                                        "single-line": "",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.processSearch,
                                        callback: function ($$v) {
                                          _vm.processSearch = $$v
                                        },
                                        expression: "processSearch",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "item.matchesInput",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  VIcon,
                                  {
                                    attrs: {
                                      color: item.matchesInput
                                        ? "green"
                                        : "grey",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.matchesInput
                                            ? "mdi-checkbox-marked-circle"
                                            : "mdi-checkbox-blank-circle-outline"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.matchesOutput",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  VIcon,
                                  {
                                    attrs: {
                                      color: item.matchesOutput
                                        ? "green"
                                        : "grey",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.matchesOutput
                                            ? "mdi-checkbox-marked-circle"
                                            : "mdi-checkbox-blank-circle-outline"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c(
                                  VAlert,
                                  {
                                    attrs: {
                                      value: true,
                                      color: "warning",
                                      icon: "mdi-alert",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.processConversionReport.noProcessesFound"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.selectedProcesses,
                          callback: function ($$v) {
                            _vm.selectedProcesses = $$v
                          },
                          expression: "selectedProcesses",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.goToPrevStep(3)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.back")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            disabled: !_vm.processValid,
                            color: "primary",
                            type: "submit",
                          },
                        },
                        [
                          _c(VIcon, { attrs: { left: "" } }, [
                            _vm._v("mdi-file-chart"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.processConversionReport.generateReport"
                                )
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }